import React, {useCallback, useContext, useEffect} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {LoaderClass} from "./LoaderClass"
import {getAuthHeader, getQueryParams, objectLang, refreshAT} from "../functions"

export const UploadAvatarToPage = () => {
    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)

    const fetch = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/user/avatar/update`,
                'POST',
                {avatar: `${getQueryParams().avatar}`},
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
            await refreshAT(auth, request)
        } catch (e) {
            window.location.replace(`/${l}/profile`)
        }
    }, [request, auth])

    useEffect(() => {
        fetch().then(() => {
           window.location.replace('/upload-avatar')
        })
    }, [fetch, auth, request])

    if (loading) {
        return <LoaderClass/>
    }
}